import React, { useState } from 'react';

const allUsers = [
  { id: 1, name: 'Alice Johnson',  email: 'alice@example.com',  role: 'Admin',  status: 'Active',   joined: 'Jan 12, 2024' },
  { id: 2, name: 'Bob Martinez',   email: 'bob@example.com',    role: 'Editor', status: 'Active',   joined: 'Feb 3, 2024'  },
  { id: 3, name: 'Carol White',    email: 'carol@example.com',  role: 'Viewer', status: 'Inactive', joined: 'Feb 18, 2024' },
  { id: 4, name: 'David Lee',      email: 'david@example.com',  role: 'Editor', status: 'Active',   joined: 'Mar 5, 2024'  },
  { id: 5, name: 'Eve Robinson',   email: 'eve@example.com',    role: 'Viewer', status: 'Active',   joined: 'Mar 22, 2024' },
  { id: 6, name: 'Frank Kim',      email: 'frank@example.com',  role: 'Admin',  status: 'Active',   joined: 'Apr 7, 2024'  },
  { id: 7, name: 'Grace Chen',     email: 'grace@example.com',  role: 'Viewer', status: 'Inactive', joined: 'Apr 19, 2024' },
  { id: 8, name: 'Henry Park',     email: 'henry@example.com',  role: 'Editor', status: 'Active',   joined: 'May 2, 2024'  },
];

const roleColors  = { Admin: { bg: 'rgba(78,115,223,0.12)',  color: '#4e73df' }, Editor: { bg: 'rgba(246,194,62,0.15)', color: '#c9a227' }, Viewer: { bg: 'rgba(28,200,138,0.12)', color: '#1cc88a' } };
const statusColors = { Active: { bg: 'rgba(28,200,138,0.12)', color: '#1cc88a' }, Inactive: { bg: 'rgba(231,74,59,0.12)', color: '#e74a3b' } };

function Avatar({ name }) {
  const initials = name.split(' ').map((n) => n[0]).join('').toUpperCase();
  const colors = ['#4e73df', '#1cc88a', '#f6c23e', '#e74a3b', '#6f42c1', '#fd7e14'];
  const bg = colors[name.charCodeAt(0) % colors.length];
  return (
    <span style={{ width: 34, height: 34, borderRadius: '50%', background: bg, color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, flexShrink: 0 }}>
      {initials}
    </span>
  );
}

function Badge({ label, styleMap }) {
  const s = styleMap[label] || {};
  return <span className="badge-status" style={s}>{label}</span>;
}

export default function Users() {
  const [search, setSearch] = useState('');
  const filtered = allUsers.filter((u) =>
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      {/* Stats */}
      <div className="stats-grid" style={{ marginBottom: 28 }}>
        {[
          { label: 'Total Users',       value: '3,420', accent: '#4e73df' },
          { label: 'Active',            value: '2,891', accent: '#1cc88a' },
          { label: 'New This Month',    value: '142',   accent: '#f6c23e' },
          { label: 'Admins',            value: '12',    accent: '#6f42c1' },
        ].map((s) => (
          <div key={s.label} className="card" style={{ borderLeft: `4px solid ${s.accent}` }}>
            <div className="card-body py-3">
              <div className="card-title">{s.label}</div>
              <div className="stat-value">{s.value}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="card">
        <div className="card-body">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <p className="section-title" style={{ margin: 0 }}>All Users</p>
            <input
              type="text"
              placeholder="Search users..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ padding: '7px 14px', borderRadius: 6, border: '1px solid var(--border-color)', background: 'var(--bg-main)', color: 'var(--text-primary)', fontSize: 13, outline: 'none', width: 220 }}
            />
          </div>
          <table className="dash-table">
            <thead>
              <tr>
                {['User', 'Email', 'Role', 'Status', 'Joined'].map((h) => <th key={h}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {filtered.map((u) => (
                <tr key={u.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <Avatar name={u.name} />
                      <span style={{ fontWeight: 600 }}>{u.name}</span>
                    </div>
                  </td>
                  <td style={{ color: 'var(--text-muted)' }}>{u.email}</td>
                  <td><Badge label={u.role}   styleMap={roleColors}   /></td>
                  <td><Badge label={u.status} styleMap={statusColors} /></td>
                  <td style={{ color: 'var(--text-muted)' }}>{u.joined}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
